module.exports = __webpack_public_path__ + "img/29-tattoo-motorcycle-piston.jpg";